// SOVRANOVA — client-side crisis net.
// Mirrors the backend SafetyService HARD_TRIGGER_PHRASES so a message created
// OFFLINE (queued for replay, and therefore never screened server-side at the
// time it is written) still surfaces support immediately. Substring match only —
// deliberately simple, $0, no network. This is a safety backstop for the offline
// window, NOT a replacement for server-side screening on reconnect.
//
// KEEP IN SYNC with backend/services/safety/SafetyService.js (HARD_TRIGGER_PHRASES).

const HARD_TRIGGER_PHRASES = [
  'kill myself', 'killing myself', 'end my life', 'want to die', 'going to die',
  'take my life', 'suicide', 'suicidal', 'hurt myself', 'self harm', 'cutting myself',
  'overdose', 'hang myself', 'not worth living', 'better off dead', 'no reason to live',
  // D0-G additions — MUST stay identical to the backend list.
  'end it all', 'unalive', 'better off without me', 'no point being alive',
  'dont want to be alive', 'end my own life',
];

// Homoglyphs that render identically to Latin. Mirror of the backend map.
const CONFUSABLES = {
  'а': 'a', 'е': 'e', 'о': 'o', 'р': 'p', 'с': 'c', 'х': 'x', 'у': 'y',
  'і': 'i', 'ѕ': 's', 'ј': 'j', 'ԁ': 'd', 'ɡ': 'g', 'ь': 'b',
  'α': 'a', 'ο': 'o', 'ρ': 'p', 'ε': 'e', 'ι': 'i', 'ν': 'v', 'τ': 't',
};

// Mirror of backend foldSurfaces(): fold once, match on both surfaces so
// "kill my self", "k i l l myself" and "end   my   life" cannot walk past the
// offline net either.
function foldSurfaces(text) {
  const flat = String(text == null ? '' : text)
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[ɐ-ʯͰ-ϿЀ-ӿ]/g, (ch) => CONFUSABLES[ch] || ch)
    .replace(/[‘’ʼ'`´]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  return { flat, squeezed: flat.replace(/ /g, '') };
}

// Returns true if the text contains an unambiguous crisis phrase.
export function localCrisisCheck(text) {
  if (!text || typeof text !== 'string') return false;
  const { flat, squeezed } = foldSurfaces(text);
  return HARD_TRIGGER_PHRASES.some((p) => {
    if (flat.includes(p)) return true;
    const sq = p.replace(/ /g, '');
    return sq.length >= 6 && squeezed.includes(sq);
  });
}

export { HARD_TRIGGER_PHRASES };
